import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class EmployeeSiteMapingService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_EmployeeSiteMapping_InsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeSiteMapping_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_EmployeeSiteMappingSelect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_EmployeeSiteMapping/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
